import React from 'react';
import type { GridReadyEvent } from 'ag-grid-community';

import GadgetLoadError from 'components/GadgetLoadError';
import { CardSkeleton } from 'components/Skeleton';
import Grid from '../../Grid/Grid';
import IncompatibleComparison from '../../IncompatibleComparison';
import MetricMatrixContext from 'contexts/MetricMatrixContext';
import PaceCard from './PaceCard';

const PaceMatrixView = ({
  isCompatibleComparison,
  isLoadingData,
  isError,
  gridOptions,
  colDefs,
  rowData,
  totalsRowData,
  visId,
  onDrillDown,
  onGridReady,
  isCardMode,
  getActualDateRange,
  getAverageDateRange,
  getExcludedDateRangeLabels,
  paceMatrix,
}: {
  isCompatibleComparison: boolean | undefined;
  isLoadingData: boolean;
  isError: boolean;
  gridOptions: any;
  colDefs: any[];
  rowData: any;
  totalsRowData: any;
  visId: string;
  onDrillDown: (term: string, ctrlKey?: boolean) => void;
  onGridReady: (event: GridReadyEvent) => void;
  isCardMode: boolean;
  getActualDateRange: any;
  getAverageDateRange: any;
  getExcludedDateRangeLabels: any;
  paceMatrix: VisualisationDefinitions.PaceMatrix;
}) => {
  if (!isCompatibleComparison) {
    return <IncompatibleComparison />;
  }

  if (isError) {
    return <GadgetLoadError />;
  }

  if (!gridOptions || isLoadingData) {
    return <CardSkeleton />;
  }

  if (isCardMode) {
    return (
      <PaceCard
        totalsRow={totalsRowData}
        paceMatrix={paceMatrix}
        getActualDateRange={getActualDateRange}
        getAverageDateRange={getAverageDateRange}
        getExcludedDateRangeLabels={getExcludedDateRangeLabels}
      />
    );
  }

  return (
    <MetricMatrixContext.Provider value={{ onDrillDown }}>
      <Grid
        columnDefs={colDefs}
        onGridReady={onGridReady}
        rowData={rowData}
        gridOptions={gridOptions}
        gridId={visId}
        hasBorders={false}
        hasDarkHeader={false}
        totalsRow={totalsRowData}
        enableHeadlessRefit
      />
    </MetricMatrixContext.Provider>
  );
};

export default PaceMatrixView;
